import React, { useMemo, useState } from "react";
import { Box, InputAdornment, Stack, TextField, Typography } from "@mui/material";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import FormTreeNav from "../FormTreeNav";
import { groupsFromAdminList } from "../formTree";

/**
 * 관리자 양식 목록 — 상신 모달과 같은 폴더 트리를 쓴다.
 *
 * 두 화면이 같은 트리를 보는 게 중요하다. 관리자가 «지출 결의서» 폴더에서 고른 양식이
 * 직원 화면에서는 다른 자리에 있으면 "그 양식이 어디 갔지" 가 된다.
 *
 * 배지 둘은 서로 다른 뜻이라 색을 나눠 뒀다.
 *  - «초안» : 저장했지만 발행 안 함 → 상신 화면은 아직 예전 내용을 쓴다
 *  - «중지» : 신규 상신 목록에서 빠짐 → 기존 문서 조회는 계속된다
 */
export default function FormListSidebar({ forms, selectedId, onSelect, dirtyId }) {
    const [q, setQ] = useState("");

    const groups = useMemo(() => {
        const kw = q.trim().toLowerCase();
        const hit = (forms || []).filter((f) =>
            !kw || `${f.name} ${f.group} ${f.code}`.toLowerCase().includes(kw));
        return groupsFromAdminList(hit);
    }, [forms, q]);

    return (
        <Box sx={{ width: 268, flexShrink: 0, borderRight: "1px solid #e2e8f0",
                   display: "flex", flexDirection: "column", height: "100%" }}>
            <Box sx={{ p: 1.25, borderBottom: "1px solid #f1f5f9" }}>
                <TextField
                    size="small" fullWidth value={q} onChange={(e) => setQ(e.target.value)}
                    placeholder="양식 검색"
                    InputProps={{ startAdornment: (
                        <InputAdornment position="start">
                            <SearchRoundedIcon sx={{ fontSize: 17, color: "#94a3b8" }} />
                        </InputAdornment>
                    ) }}
                />
            </Box>

            <Box sx={{ flex: 1, overflowY: "auto", py: 0.5 }}>
                <FormTreeNav
                    groups={groups}
                    keyOf={(f) => f.id}
                    selected={selectedId}
                    onSelect={onSelect}
                    query={q}
                    renderRight={(f) => (
                        <Stack direction="row" spacing={0.4} sx={{ flexShrink: 0 }}>
                            {(f.hasDraft || f.id === dirtyId) && <Badge text="초안" color="#b45309" bg="#fef3c7" />}
                            {!f.active && <Badge text="중지" color="#64748b" bg="#f1f5f9" />}
                        </Stack>
                    )}
                />
                {groups.length === 0 && (
                    <Typography sx={{ p: 2, fontSize: 12, color: "#94a3b8" }}>검색 결과 없음</Typography>
                )}
            </Box>
        </Box>
    );
}

function Badge({ text, color, bg }) {
    return (
        <Box sx={{ px: 0.6, py: 0.1, borderRadius: 0.75, bgcolor: bg, color,
                   fontSize: 10, fontWeight: 800 }}>
            {text}
        </Box>
    );
}
